import React from "react";
import ServicesImg from "../../assets/img/service/ServicesImg.webp";

import {
  ServicesCircleIcon,
  ServicesCloudIcon,
  ServicesHomeIcon,
  ServicesMobileIcon,
} from "../common/Icons";
const Services = () => {
  return (
    <>
      <section className="py-5 open_overlay_sections_none" id="services">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="d-inline main_heading px-3 py-2 bg_red ">
              Services
            </h2>
          </div>
          <div className="row justify-content-center justify-content-lg-between align-items-center">
            <div
              className="col-lg-6 mb-lg-0"
              data-aos="fade-up-right"
              data-aos-duration="1500"
            >
              <div>
                <div className="d-flex mb-3 mb-lg-4 card_shadow p-3">
                  <div>
                    <span>
                      <ServicesCloudIcon />
                    </span>
                  </div>
                  <div className="">
                    <h2 className="main_para font-md fw-semibold">
                      Mi, tristique metus, amet,
                    </h2>
                    <p className="main_para mb-0">
                      Vulputate morbi nisl, erat elementum magna velit
                      scelerisque sapien, massa. Diam auctor sit sed facilisis
                      sed. Pretium nec egestas feugiat sed convallis. Et risus.
                    </p>
                  </div>
                </div>
                <div className="d-flex mb-3 mb-lg-4 card_shadow p-3">
                  <div>
                    <span>
                      <ServicesMobileIcon />
                    </span>
                  </div>
                  <div className="ms-3">
                    <h2 className="main_para font-md fw-semibold">
                      Viverra at facilisi enim
                    </h2>
                    <p className="main_para mb-0">
                      Sodales laoreet sit tempor, urna, justo, auctor sed
                      posuere massa. Id risus porttitor donec accumsan ut
                      tellus.
                    </p>
                  </div>
                </div>
                <div className="d-flex mb-3 mb-lg-4 card_shadow p-3">
                  <div>
                    <span>
                      <ServicesCircleIcon />
                    </span>
                  </div>
                  <div>
                    <h2 className="main_para font-md fw-semibold">
                      Malesuada vivamus
                    </h2>
                    <p className="main_para mb-0">
                      Quam est proin ante eleifend porttitor imperdiet
                      pellentesque dui odio. Ultrices lorem nulla dolor non
                      vitae. Risus, purus
                    </p>
                  </div>
                </div>
                <div className="d-flex mb-3 mb-lg-4 card_shadow p-3">
                  <div>
                    <span>
                      <ServicesHomeIcon />
                    </span>
                  </div>
                  <div>
                    <h2 className="main_para font-md fw-semibold">
                      Quam vitae lorem
                    </h2>
                    <p className="main_para mb-0">
                      Eget in sagittis, sem penatibus ultrices ultrices. Eu,
                      lacus eu, maecenas aenean viverra. Non ut vehicula tempor
                      eget elementum mauris consectetur.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-lg-5"
              data-aos="fade-up-left"
              data-aos-duration="1500"
            >
              <div className="moving_animation_img py-lg-0 pt-5">
                <img className="w-100" src={ServicesImg} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Services;
